import { gql } from '@apollo/client'

import { PROMOTION_APPLICATION_FIELDS } from './promotion'

export const CONFIRM_PRIMITIVE_RESERVATION = gql`
  mutation ConfirmPrimitiveReservation(
    $input: ConfirmPrimitiveReservationInput
  ) {
    confirmPrimitiveReservation(input: $input) {
      reservationNumber
      reservationInfo {
        paymentMethods
        detailedRoomStays {
          arrival
          departure
          roomTypeCode
          ratePlanCode
          roomTypeName
          ratePlanName
          boardType
          guests {
            name
            email
            mobile
          }
          chargePerDays {
            date
            charge {
              itemName
              quantity
              discount
              rate
              total
              remark
            }
          }
          chargePerRoomStay {
            itemName
            quantity
            discount
            rate
            total
            remark
          }
          discount
          occupancy {
            adults
            extraBeds
          }
          totalChargePerRoomStay
          totalChargePerDay
          roomStayReference
        }
        totalAmount {
          discount
          payable
        }
        expiresAt
        selectedRooms {
          roomTypeName
          ratePlanName
          occupancy {
            adults
            extraBeds
          }
          boardType
          checkIn
          checkOut
        }
        booker {
          firstName
          lastName
          email
          mobile
        }
        promotionApplication {
          __typename
          ...PromotionApplicationFields
        }
      }
      paymentInfo {
        walletID
        walletType
        isBilateral
        cashBalance
        remainingCreditBalance
        currency
        creditorID
      }
      billingSummary {
        roomsPrice {
          roomTypeName
          ratePlanCode
          quantity
          price
        }
        subTotalPrice {
          subTotalBeforeDiscount
          discount
          additionalDiscount
          subTotalAfterDiscount
        }
        taxAndFees
        totalPayable
        curruncy
      }
    }
  }
  ${PROMOTION_APPLICATION_FIELDS}
`

export const MAKE_PRIMITIVE_RESERVATION = gql`
  mutation MakePrimitiveReservation($input: MakePrimitiveReservationInput!) {
    makePrimitiveReservation(input: $input) {
      reservationNumber
      optionReserveMaxExpireTime
      isAuthorizedToDeclareOptionReserve
      isAutorizedToDeclareDiscount
      roomStays {
        arrival
        departure
        crsNumber
        roomStayReference
        roomTypeName
        roomTypeCode
        ratePlanName
        ratePlanCode
        price {
          beforeDiscount {
            roomPrice
            extraBedPrice
            totalPrice
          }
          afterDiscount {
            roomPrice
            extraBedPrice
            totalPrice
          }
        }
        pricePerDay {
          date
          price {
            beforeDiscount {
              roomPrice
              extraBedPrice
              totalPrice
            }
            afterDiscount {
              roomPrice
              extraBedPrice
              totalPrice
            }
          }
        }
        occupancy {
          adults
          extraBeds
        }
        boardType
      }
      paymentInfo {
        walletID
        walletType
        isBilateral
        cashBalance
        remainingCreditBalance
        currency
        creditorID
      }
      providerCode
      providerName
      propertyCode
      propertyName
      expiresAt
      billingSummary {
        roomsPrice {
          roomTypeName
          ratePlanCode
          quantity
          price
        }
        subTotalPrice {
          subTotalBeforeDiscount
          discount
          subTotalAfterDiscount
        }
        taxAndFees
        totalPayable
        curruncy
      }
      selectedRooms {
        roomTypeName
        ratePlanName
        boardType
        occupancy {
          adults
          extraBeds
        }
        checkIn
        checkOut
      }
      showReservationType
      promotionApplication {
        __typename
        ...PromotionApplicationFields
      }
    }
  }
  ${PROMOTION_APPLICATION_FIELDS}
`
